import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  if($('.section1 .banner-sub-title a').length){
    let paddingLeft = $('.section1 .banner-sub-title').css("padding-left")
    let navLeft = $('.section1 .banner-sub-title a.active').offset().left - parseInt(paddingLeft.replace('px', ''))
    $('.section1 .banner-sub-title').scrollLeft(navLeft)
  }

  let swipers = $('.img-swiper')
  for(let i = 0; i < swipers.length; i++){
    new Swiper($(swipers[i]).find('.swiper')[0], {
      speed: 600,
      effect : 'fade',
      watchOverflow: true,
      loop: true,
      autoplay: { // 自动切换
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      pagination: {// 分页
        el: $(swipers[i]).find('.swiper-pagination')[0],
        clickable: true,
      },
    });
  }
})

var mouseover_tid3 = [];
var mouseout_tid3 = [];
$(document).ready(function () {
  $(".section1 .banner-sub-title a:not(.active)").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid3[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid3[ index ] = setTimeout(function () {
          $(_self).find('b').animate({opacity:"1",bottom:"8%"},300)
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid3[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid3[ index ] = setTimeout(function () {
          $(_self).find('b').animate({opacity:"0",bottom:"-5%"},300).animate({bottom:"22%"},0)
        }, 201);
      });
    });
});